'use client'

import { useState, useEffect } from 'react'
import Link from 'next/link'
import { X } from 'lucide-react'

const CONSENT_KEY = 'cookie-consent'
const SHOW_DELAY_MS = 3000

export function CookieBanner() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    const consent = localStorage.getItem(CONSENT_KEY)
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), SHOW_DELAY_MS)
      return () => clearTimeout(timer)
    }
  }, [])

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted')
    setVisible(false)
  }

  const dismiss = () => {
    localStorage.setItem(CONSENT_KEY, 'dismissed')
    setVisible(false)
  }

  if (!visible) return null

  return (
    <div className="fixed bottom-0 inset-x-0 z-[9999] pointer-events-none">
      <div className="max-w-3xl mx-auto px-4 pb-4">
        <div className="pointer-events-auto bg-white/55 backdrop-blur-lg backdrop-saturate-150 border border-white/30 rounded-2xl shadow-lg shadow-black/5 px-5 py-4 flex items-center gap-4 animate-in fade-in slide-in-from-bottom-4 duration-700">
          <p className="text-sm text-gray-800 flex-1 font-semibold">
            We use cookies for analytics and to improve your experience.{' '}
            <Link
              href="/privacy-policy"
              className="underline whitespace-nowrap"
            >
              Privacy Policy
            </Link>
          </p>
          <div className="flex items-center gap-2 shrink-0">
            <button
              onClick={accept}
              className="px-4 py-1.5 text-sm font-medium bg-brand-blue/90 text-white rounded-full hover:bg-brand-blue transition-colors backdrop-blur-sm"
            >
              Accept
            </button>
            <button
              onClick={dismiss}
              className="p-1.5 text-gray-600 hover:text-gray-800 transition-colors rounded-full hover:bg-white/40"
              aria-label="Dismiss"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
